import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Col,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import style from "./Field.module.scss";
import classnames from "classnames";

const Side = (props) => {
  const { readonly, withOpenClose } = props;

  let component = null;

  if (readonly) {
    component = <SideReadOnly {...props} />;
  } else {
    if (withOpenClose) {
      component = <BuySellOpenClose {...props} />;
    } else {
      component = <BuySell {...props} />;
    }
  }

  return component;
};

Side.propTypes = {};

const SideReadOnly = ({ side, OrderOpenClose, withOpenClose }) => {
  return (
    <div
      className={classnames("mb-2", style.side, style.readonly, {
        [style.buy]: side == "Buy",
        [style.sell]: side == "Sell",
      })}
    >
      {side}
      {withOpenClose ? OrderOpenClose : null}
    </div>
  );
};

const BuySellOpenClose = ({ side, openClose, onChange }) => {
  return (
    <div className={classnames({ [style.side]: true, [style.buySellOpenClose]: true })}>
      <UncontrolledDropdown style={{ width: "100%" }}>
        <DropdownToggle caret className={side == "Buy" ? style.buy : style.sell}>
          {side} {openClose}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => onChange({ OrderSide: "Buy", OrderOpenClose: "Open" })}
            className={style.itemBuy}
          >
            Buy Open
          </DropdownItem>
          <DropdownItem
            onClick={() => onChange({ OrderSide: "Buy", OrderOpenClose: "Close" })}
            className={style.itemBuy}
          >
            Buy Close
          </DropdownItem>
          <DropdownItem
            onClick={() => onChange({ OrderSide: "Sell", OrderOpenClose: "Open" })}
            className={style.itemSell}
          >
            Sell Open
          </DropdownItem>
          <DropdownItem
            onClick={() => onChange({ OrderSide: "Sell", OrderOpenClose: "Close" })}
            className={style.itemSell}
          >
            Sell Close
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

const BuySell = ({ side, onChange }) => (
  <div className={classnames({ [style.side]: true, [style.buySell]: true })}>
    <Button
      onClick={() => onChange({ OrderSide: "Buy" })}
      className={`${style.buy} ${side == "Buy" ? "" : style.off}`}
      disabled={side == "Buy"}
    >
      Buy
    </Button>

    <Button
      onClick={() => onChange({ OrderSide: "Sell" })}
      className={`${style.sell} ${side == "Buy" ? style.off : ""}`}
      disabled={side != "Buy"}
    >
      Sell
    </Button>
  </div>
);

export default React.memo(Side);
